/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const RefreshIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="RefreshIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M13.4999 8C13.4999 4.96243 11.0375 2.5 7.99994 2.5C6.76235 2.5 5.61892 2.90936 4.69965 3.59985L5.30023 4.39942C6.05228 3.83453 6.98632 3.5 7.99994 3.5C10.4852 3.5 12.4999 5.51472 12.4999 8V8.79298L10.8535 7.14649L10.1463 7.8536L12.9999 10.7072L15.8535 7.8536L15.1463 7.14649L13.4999 8.7929V8Z"
                fill="currentColor"
              />
              <path
                d="M3.49994 7.2071L5.14635 8.85351L5.85345 8.1464L2.9999 5.29285L0.146348 8.1464L0.853455 8.85351L2.49994 7.20702V8C2.49994 11.0376 4.96237 13.5 7.99994 13.5C9.23753 13.5 10.381 13.0906 11.3002 12.4001L10.6996 11.6006C9.9476 12.1655 9.01356 12.5 7.99994 12.5C5.51466 12.5 3.49994 10.4853 3.49994 8V7.2071Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

RefreshIcon.tags = [
  'arrows',
  'circle',
  'recycle',
  'reload',
  'update',
  'sync',
  'repeat',
];

RefreshIcon.category = 'General Icons';

RefreshIcon.iconSize = 16;
